//==> Program Array nested in questionSEVEN.qna
const questionONE = {
  indexNum: "one",
  question: "What is your age?",
  progress: 1,
  qna: [{
    qNum: "one",
    option: "Teen",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/core.png?v=1599083845",
    response: "Training starts with a repeatable setup. Learn the movements, follow the sessions and give yourself time to recover."
  },{
    qNum: "two",
    option: "20",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/core.png?v=1599083845",
    response: "Training starts with a repeatable setup. Learn the movements, follow the sessions and give yourself time to recover."
  },{
    qNum: "three",
    option: "30",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/core.png?v=1599083845",
    response: "Training starts with a repeatable setup. Learn the movements, follow the sessions and give yourself time to recover."
  },{
    qNum: "four",
    option: "40",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/core.png?v=1599083845",
    response: "Training starts with a repeatable setup. Learn the movements, follow the sessions and give yourself time to recover."
  },{
    qNum: "five",
    option: "50",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/core.png?v=1599083845",
    response: "Training starts with a repeatable setup. Learn the movements, follow the sessions and give yourself time to recover."
  },{
    qNum: "six",
    option: "60",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/core.png?v=1599083845",
    response: "Training starts with a repeatable setup. Learn the movements, follow the sessions and give yourself time to recover."
  }]
};

const questionTWO = {
  indexNum: "two",
  question: "Describe your energy/stress level?",
  progress: 2,
  qna: [{
    qNum: "one",
    option: "Steady Energy / Low Stress",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/energy.png?v=1596478177",
    response: ""
  },{
    qNum: "two",
    option: "Low Energy / Low Stress",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/energy.png?v=1596478177",
    response: "Build a training routine that fits your week. Keep the sessions manageable and leave time between them to recover."
  },{
    qNum: "three",
    option: "Low Energy / High Stress",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/energy.png?v=1596478177",
    response: "Build a training routine that fits your week. Keep the sessions manageable and leave time between them to recover."
  },{
    qNum: "four",
    option: "High Energy / High Stress",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/energy.png?v=1596478177",
    response: "Build a training routine that fits your week. Keep the sessions manageable and leave time between them to recover."
  }]
};

const questionTHREE = {
  indexNum: "three",
  question: "Do you experience the following?",
  subText: "[Select all that apply]",
  progress: 3,
  qna: [{
    qNum: "one",
    option: "Acne",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/dna.png?v=1596478177",
    response: "This quiz matches your training goal to a program. It does not assess symptoms or hormone levels."
  },{
    qNum: "two",
    option: "Tiredness/Brain Fog",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/dna.png?v=1596478177",
    response: "This quiz matches your training goal to a program. It does not assess symptoms or hormone levels."
  },{
    qNum: "three",
    option: "Candida/Yeast Infections",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/dna.png?v=1596478177",
    response: "This quiz matches your training goal to a program. It does not assess symptoms or hormone levels."
  },{
    qNum: "four",
    option: "Irritability & Mood Swings",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/dna.png?v=1596478177",
    response: "This quiz matches your training goal to a program. It does not assess symptoms or hormone levels."
  },{
    qNum: "five",
    option: "None of the Above",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/intestine.png?v=1596478177",
    response: ""
  }]
};

const questionFOUR = {
  indexNum: "four",
  question: "Describe your digestive health",
  subText: "[Bloating, Excessive Gas, Constipation, IBS, Acid Reflux]",
  progress: 4,
  qna: [{
    qNum: "one",
    option: "Good, No Issues",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/intestine.png?v=1596478177",
    response: "A training program cannot determine the cause of digestive symptoms. The recommendation below follows the training goal you selected."
  },{
    qNum: "two",
    option: "Occasional Issues",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/intestine.png?v=1596478177",
    response: "A training program cannot determine the cause of digestive symptoms. The recommendation below follows the training goal you selected."
  },{
    qNum: "three",
    option: "Frequent Issues",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/intestine.png?v=1596478177",
    response: "A training program cannot determine the cause of digestive symptoms. The recommendation below follows the training goal you selected."
  }]
};

const questionFIVE = {
  indexNum: "five",
  question: "How many meals do you usually eat?",
  progress: 5,
  qna: [{
    qNum: "one",
    option: "1-2 meals a day",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/nutrition.png?v=1596478176",
    response: "Food is part of training. Keep meals practical and make room for protein alongside your sessions."
  },{
    qNum: "two",
    option: "3 meals a day",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/nutrition.png?v=1596478176",
    response: "Food is part of training. Keep meals practical and make room for protein alongside your sessions."
  },{
    qNum: "three",
    option: "3-4 meals a day w/ snacks",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/nutrition.png?v=1596478176",
    response: "Food is part of training. Keep meals practical and make room for protein alongside your sessions."
  },{
    qNum: "four",
    option: "4 meals a day",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/nutrition.png?v=1596478176",
    response: "Food is part of training. Keep meals practical and make room for protein alongside your sessions."
  },{
    qNum: "five",
    option: "4 meals a day w/ snacks",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/nutrition.png?v=1596478176",
    response: "Food is part of training. Keep meals practical and make room for protein alongside your sessions."
  }]
};

const questionSIX = {
  indexNum: "six",
  question: "Tell me about your current fitness.",
  subText: "[Select the best answer]",
  progress: 6,
  qna: [{
    qNum: "one",
    option: "Inactive",
    optionSubText: "",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/health.jpg?v=1599107631",
    response: "Start with the exercise setup. Give yourself time to learn each movement and follow the sessions at a manageable pace."
  },{
    qNum: "two",
    option: "Cardio and machines",
    optionSubText: "(Elliptical, cable & weight machines)",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/back.jpg?v=1599093198",
    response: "Start with the exercise setup. Give yourself time to learn each movement and follow the sessions at a manageable pace."

  },{
    qNum: "three",
    option: "Lifting weights",
    optionSubText: "(Rows, deadlifts, HIIT, squats, etc)",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/muscle.png?v=1596478177",
    response: "Start with the exercise setup. Give yourself time to learn each movement and follow the sessions at a manageable pace."
   },{
    qNum: "four",
    option: "Group fitness classes",
    optionSubText: "(Zumba, Pilates, Yoga, Spin, F15, etc)",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/fire.png?v=1596478177",
    response: "Start with the exercise setup. Give yourself time to learn each movement and follow the sessions at a manageable pace."
   }]
};

const questionSEVEN = {
  indexNum: "seven",
  question: "What is your ideal body type?",
  subText: "[Pick One of Four]",
  progress: 7,
  qna: [{
    qNum: "one",
    response: "Fighter",
    option: ["Rock hard build, 6-pack & vascular biceps"],
    horoscope: "The Fighter is designed to help you feel strong and look strong. This program is ideal for those wanting to build hyper-defined muscles for confidence and strength. A MoMo favorite!",
    bulletPoints: ["Rock hard upper body", "Poppin’ veins & biceps", "V-lines & defined 6-pack", "Lean muscle & athleticism"  ],
    leadPages: "SqVbSgvvwrFUCgBxTVRKZf",
    image: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/Black_Flex.jpg?v=1641718889",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/core.png?v=1599083845",
    productImg: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/fighter-flat-cover_thumbnail.png?v=1634750525",
    link: "https://www.momomuscle.co/collections/all/products/the-fighter-program",
    reviews: [{
      img: `https://cdn.shopify.com/s/files/1/0017/7533/7583/files/momomuscle_BnA_28.png?v=1656571333`,
      txt: `I'm 40 and got those results in 5 weeks. It's different than being in the 20s. The Fighter, especially the nutriton, got me in the best shape of my life.`
      },{
      img: `https://cdn.shopify.com/s/files/1/0017/7533/7583/files/Testimonials-4_2.png?v=1661408607`,
      txt: `First and only time i’ve felt good about my bod, even got the toxic masculinity gym bros from back in high school in my dms telling me i look jacked 😤`
    },{
      img: `https://cdn.shopify.com/s/files/1/0017/7533/7583/files/Testimonials-18_1.png?v=1661408608`,
      txt: `This is about 9 months between photos, down 35 lbs and I feel strong as hell. The Fighter changed my life and I couldn’t have done it without you! `
    }]
  },{
    qNum: "two",
    response: "Legend",
    option: ["Maximal amount of muscle & strength"],
    horoscope: "The Legend is designed to help you unlock previously unattainable gains and bust through progress plateaus. This program is ideal for experienced lifters wanting to build muscle mass for a jaw dropping physique.",
    bulletPoints: [ "Dense bulletproof muscles", "Full body strength gains", "Impressive size and power", "Thick, turtle shell 6-pack" ],
    leadPages: "qofvBPbntvdfWw2GJq26pi",
    image: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/the-legend.png?v=1602890471",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/core.png?v=1599083845",
    productImg: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/legend-flat-cover_thumbnail.png?v=1634750526",
    link: "https://www.momomuscle.co/collections/all/products/the-legend-program",
    reviews: [{
      img: `https://cdn.shopify.com/s/files/1/0017/7533/7583/files/momomuscle_BnA_30.png?v=1656571333`,
      txt: `I'm grateful to have found a program and community that lines up with my goals and lifestyle. I started on the Legend and then moved to the Fighter Feed on the app. For the first time in years, I am injury free and getting stronger every week.`
      },{
      img: `https://cdn.shopify.com/s/files/1/0017/7533/7583/files/momomuscle_BnA_01.png?v=1656571333`,
      txt: `Hey! I started using the legend program around 6 months ago. Just wanted to thank you for making this program and all of your content. This is the first time I haven’t felt extremely dysphoric about my hips!`
    },{
      img: `https://cdn.shopify.com/s/files/1/0017/7533/7583/files/momomuscle_BnA_18.png?v=1656571333`,
      txt: `The Legend Program gets you jacked!  No lie.`
    }]
  },{
    qNum: "three",
    response: "Model",
    option: ["Slender, lean & perfect posture"],
    horoscope: "The Model is designed to supercharge fat loss, improve posture, and totally shred the body. This program is ideal for those wanting to increase the impact of conditioning without putting on muscle.",
    bulletPoints: [ "Tight abs, arms and booty", "Confident, attractive posture", "Maximum fat shredding", "Lean, defined figure" ],
    leadPages: "U7p8AVTAsNKFpf9g6nieJW",
    image: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/THE_MODEL.jpg?v=1641718889",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/core.png?v=1599083845",
    productImg: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/model-flat-cover_thumbnail.png?v=1634751737",
    link: "https://www.momomuscle.co/collections/all/products/model-program",
    reviews: [{
      img: `https://cdn.shopify.com/s/files/1/0017/7533/7583/files/momomuscle_BnA_12.png?v=1656571333`,
      txt: `I see more definition in my shoulders, back and abs. I also have a shit ton more energy. My biggest gains, though, are in my self-confidence and attitude! I wasn’t able to do this without the guidance and support from Morgan Olson and the amazing community that she have brought together! Coach, you are exactly what our community needs. Thank you so much!`
      },{
      img: `https://cdn.shopify.com/s/files/1/0017/7533/7583/files/momomuscle_BnA_09.png?v=1656571333`,
      txt: `Just wanna say thank you for giving such helpful advice!! This is a 4 month difference and thank you for kicking my ass🥰`
    },{
      img: `https://cdn.shopify.com/s/files/1/0017/7533/7583/files/momomuscle_BnA_10.png?v=1656571333`,
      txt: `I mean every word, your Model Program is 10xs more informative for like half the price of all the other shit I’ve tried. You should be super proud! `
    }]
  },{
    qNum: "four",
    response: "Surfer",
    option: ["Bikini booty, sculpted shoulders & tight waist"],
    horoscope: "The Surfer is designed to sculpt and tone with a focus on building a Brazilian butt, arms, and abs. This program is ideal for those wanting a bikini body with an athletic twist.",
    bulletPoints: [ "Sculpted abs, arms, & booty", "Body confidence and posture", "Fat shredding and lean muscle", "Athletic bikini body" ],
    leadPages: "igSUpLquKaPSExJnbSN9Rn",
    image: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/quiz_surfer.jpg?v=1671500177",
    icon: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/core.png?v=1599083845",
    productImg: "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/surfer-flat-cover_thumbnail.png?v=1634750526",
    link: "https://www.momomuscle.co/collections/all/products/the-surfer-program",
    reviews: [{
      img: `https://cdn.shopify.com/s/files/1/0017/7533/7583/files/momomuscle_BnA_36.png?v=1656571333`,
      txt: `Aww well I’m just so happy I found your program. It’s truly inspiring to see everyone doing it and their progress 😉`
      },{
      img: `https://cdn.shopify.com/s/files/1/0017/7533/7583/files/momomuscle_BnA_35.png?v=1656571333`,
      txt: `I’m actually feeling happiest about is that my bloating has gone down. Thanks Momo for the program and great workouts. I’ll be on the Surfer Program for life! `
    },{
      img: `https://cdn.shopify.com/s/files/1/0017/7533/7583/files/momomuscle_BnA_29.png?v=1656571333`,
      txt: `3 months difference thanks to you ❤️ I’ve been off track a couple times but for the most part I’ve stuck to the nutrition and your workout program the surfer. Thank you so much! 😊`
    }]
  }]
};

const questionEIGHT = {
  indexNum: "eight",
  question: "What would you love to achieve?",
  subText: "[Select all the apply]",
  progress: 8,
  qna: [{
    qNum: "one",
    option: "Improve Digestion"
  },{
    qNum: "two",
    option: "Confident Posture"
  },{
    qNum: "three",
    option: "Brazilian Booty"
  },{
    qNum: "four",
    option: "Clarity & Energy"
  },{
    qNum: "five",
    option: "Tighter Waist"
  },{
    qNum: "six",
    option: "Stronger Upper Body"
  },{
    qNum: "seven",
    option: "Ripped Abs"
  },{
    qNum: "eight",
    option: "Visible Veins"
  }]
};

//========> Response Headshot & Signature
const headshot = 'https://cdn.shopify.com/s/files/1/0017/7533/7583/files/momo_headshot_square.jpg?v=1659908400';
const signature = 'https://cdn.shopify.com/s/files/1/0017/7533/7583/files/Morgan_signature_darkgrey.png?v=1600379034';